import smoothscroll from 'smoothscroll-polyfill';

let isContentMenuActive = false;

export default function contentMenu() {
  smoothscroll.polyfill();

  const contentMenuHeader = document.getElementById('contentMenuHeader');
  const contentNavigationMenu = document.getElementById('contentMenu');
  const article = document.getElementsByTagName('article');
  const headers = article[0].getElementsByTagName('h2');
  const contentNavMenuItem = document.getElementsByClassName('articleNav__item');

  // helpers
  function isLaptopMode() {
    const documentWidth = (
      window.innerWidth
        || document.body.clientWidth
        || document.documentElement.clientWidth
    );
    const MIN_LAPTOP_WIDTH = 992;

    return documentWidth >= MIN_LAPTOP_WIDTH;
  }

  const changeActiveMenuTabWhileScroll = () => {
    const articleHeadersPos = [];
    for (let i = 0; i < headers.length; i++) {
      articleHeadersPos.push(
        headers[i].getBoundingClientRect().top - document.body.getBoundingClientRect().top,
      );
    }
    const winY = window.pageYOffset;

    if (winY < articleHeadersPos[0]) {
      contentNavMenuItem[0].classList.add('active');
      return;
    }
    if (winY > articleHeadersPos[articleHeadersPos.length - 1]) {
      contentNavMenuItem[contentNavMenuItem.length - 1].classList.add('active');
      return;
    }
    for (let i = 0; i < articleHeadersPos.length; i++) {
      if (
        i + 1 <= articleHeadersPos.length
        && winY > articleHeadersPos[i]
        && winY < articleHeadersPos[i + 1]
      ) {
        for (let k = 0; k < contentNavMenuItem.length; k++) {
          if (k === i) {
            contentNavMenuItem[k].classList.add('active');
          } else {
            contentNavMenuItem[k].classList.remove('active');
          }
        }
      }
    }
  };

  // handlers

  const scrollHandler = () => {
    changeActiveMenuTabWhileScroll();
  };

  const scrollToElementTopHandler = (elem, offset) => {
    const rect = elem.getBoundingClientRect();
    const targetPosition = rect.top - document.body.getBoundingClientRect().top + offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });

    return new Promise((resolve) => {
      const scrollPlugHandler = () => {
        const pageY = Math.round(window.pageYOffset);
        const currentY = Math.round(targetPosition);
        if (
          pageY === currentY
          || pageY === currentY + 1
          || pageY === currentY - 1
          || pageY === currentY + 2
          || pageY === currentY - 2
          || pageY === currentY + 3
          || pageY === currentY - 3
        ) {
          window.removeEventListener('scroll', scrollPlugHandler);
          resolve();
        }
      };
      window.addEventListener('scroll', scrollPlugHandler);
    });
  };

  const onChangeContentMenuActive = () => {
    if (isLaptopMode()) return;

    if (!isContentMenuActive) {
      contentMenuHeader.classList.remove('articleNav__title');
      contentMenuHeader.classList.add('articleNav__title_active');

      contentNavigationMenu.classList.remove('articleNav__content_hidden');
      contentNavigationMenu.classList.add('articleNav__content');

      isContentMenuActive = true;
    } else {
      contentMenuHeader.classList.remove('articleNav__title_active');
      contentMenuHeader.classList.add('articleNav__title');

      contentNavigationMenu.classList.add('articleNav__content_hidden');
      contentNavigationMenu.classList.remove('articleNav__content');

      isContentMenuActive = false;
    }
  };

  for (let k = 0; k < contentNavMenuItem.length; k++) {
    contentNavMenuItem[k].addEventListener('click', (e) => {
      if (isLaptopMode()) {
        window.removeEventListener('scroll', scrollHandler);
      }

      for (let j = 0; j < contentNavMenuItem.length; j++) {
        if (j === k) {
          contentNavMenuItem[j].classList.add('active');
        } else {
          contentNavMenuItem[j].classList.remove('active');
        }
      }
      for (let i = 0; i < headers.length; i++) {
        if (e.target.innerText === headers[i].innerText) {
          scrollToElementTopHandler(headers[i], isLaptopMode() ? 20 : -70).then(() => {
            if (isLaptopMode()) {
              window.addEventListener('scroll', scrollHandler);
            }
          });
        }
      }
    });
  }

  if (isLaptopMode()) {
    changeActiveMenuTabWhileScroll();
  }

  contentMenuHeader.addEventListener('click', onChangeContentMenuActive);
  if (isLaptopMode()) {
    window.addEventListener('scroll', scrollHandler);
  }
}
